import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  updateEventChartFilter(state, payload) {
    state.eventId = payload.eventId;
    state.eventStartDate = payload.eventStartDate;
    state.eventEndDate = payload.eventEndDate;
    state.eventPeriod = payload.eventPeriod;
    state.eventShowCategory = payload.eventShowCategory;
  },
  updateOfficialChartFilter(state, payload) {
    state.officialStartDate = payload.officialStartDate;
    state.officialEndDate = payload.officialEndDate;
    state.officialPeriod = payload.officialPeriod;
    state.officialShowCategory = payload.officialShowCategory;
  },
  updateScoutChartFilter(state, payload) {
    state.scoutStartDate = payload.scoutStartDate;
    state.scoutEndDate = payload.scoutEndDate;
    state.scoutPeriod = payload.scoutPeriod;
    state.scoutShowCategory = payload.scoutShowCategory;
    state.scoutTemplateId = payload.scoutTemplateId;
  }
};

export default mutations;
